/**
 * Реестр секций
 *
 * Для добавления новой секции:
 * 1. Скопируй папку _template
 * 2. Переименуй и заполни schema.js, index.jsx, Settings.jsx, Thumbnail.jsx
 * 3. Добавь импорт и экспорт ниже (Component, Settings, schema, Thumbnail)
 */

// Импорты секций
import HeroSection from './Hero';
// Hero uses schema-driven settings (no Settings.jsx)
import heroSchema from './Hero/schema';
import HeroThumbnail from './Hero/Thumbnail';

import HeroSplitSection from './HeroSplit';
// HeroSplit uses schema-driven settings (no Settings.jsx)
import heroSplitSchema from './HeroSplit/schema';
import HeroSplitThumbnail from './HeroSplit/Thumbnail';

import HeroMinimalSection from './HeroMinimal';
// HeroMinimal uses schema-driven settings (no Settings.jsx)
import heroMinimalSchema from './HeroMinimal/schema';
import HeroMinimalThumbnail from './HeroMinimal/Thumbnail';

import HeroCenteredSection from './HeroCentered';
// HeroCentered uses schema-driven settings (no Settings.jsx)
import heroCenteredSchema from './HeroCentered/schema';
import HeroCenteredThumbnail from './HeroCentered/Thumbnail';

import FeaturesSection from './Features';
// Features uses schema-driven settings (no Settings.jsx)
import featuresSchema from './Features/schema';
import FeaturesThumbnail from './Features/Thumbnail';

import HowItWorksSection from './HowItWorks';
// HowItWorks uses schema-driven settings (no Settings.jsx)
import howItWorksSchema from './HowItWorks/schema';
import HowItWorksThumbnail from './HowItWorks/Thumbnail';

import GallerySection from './Gallery';
// Gallery uses schema-driven settings (no Settings.jsx)
import gallerySchema from './Gallery/schema';
import GalleryThumbnail from './Gallery/Thumbnail';

import PricingSection from './Pricing';
import PricingSettings from './Pricing/Settings';
import pricingSchema from './Pricing/schema';
import PricingThumbnail from './Pricing/Thumbnail';

import TestimonialsSection from './Testimonials';
// Testimonials uses schema-driven settings (no Settings.jsx)
import testimonialsSchema from './Testimonials/schema';
import TestimonialsThumbnail from './Testimonials/Thumbnail';

import ContactSection from './Contact';
import ContactSettings from './Contact/Settings';
import contactSchema from './Contact/schema';
import ContactThumbnail from './Contact/Thumbnail';

import OfficesSection from './Offices';
import OfficesSettings from './Offices/Settings';
import officesSchema from './Offices/schema';
import OfficesThumbnail from './Offices/Thumbnail';

import ButtonSection from './ButtonSection';
// ButtonSection uses schema-driven settings (no Settings.jsx)
import buttonSectionSchema from './ButtonSection/schema';
import ButtonSectionThumbnail from './ButtonSection/Thumbnail';

import RichText from './RichText';
import RichTextSettings from './RichText/Settings';
import richTextSchema from './RichText/schema';
import RichTextThumbnail from './RichText/Thumbnail';

import FAQ from './FAQ';
// FAQ uses schema-driven settings (no Settings.jsx)
import faqSchema from './FAQ/schema';
import FAQThumbnail from './FAQ/Thumbnail';

import Divider from './Divider';
// Divider uses schema-driven settings (no Settings.jsx)
import dividerSchema from './Divider/schema';
import DividerThumbnail from './Divider/Thumbnail';

import NavigationSection from './Navigation';
import NavigationSettings from './Navigation/Settings';
import navigationSchema from './Navigation/schema.json';
import NavigationThumbnail from './Navigation/Thumbnail';

import VideoSection from './Video';
// Video uses schema-driven settings (no Settings.jsx)
import videoSchema from './Video/schema';
import VideoThumbnail from './Video/Thumbnail';

// Реестр всех секций
export const sections = {
  hero: {
    Component: HeroSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: heroSchema,
    Thumbnail: HeroThumbnail
  },
  herosplit: {
    Component: HeroSplitSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: heroSplitSchema,
    Thumbnail: HeroSplitThumbnail
  },
  herominimal: {
    Component: HeroMinimalSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: heroMinimalSchema,
    Thumbnail: HeroMinimalThumbnail
  },
  herocentered: {
    Component: HeroCenteredSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: heroCenteredSchema,
    Thumbnail: HeroCenteredThumbnail
  },
  features: {
    Component: FeaturesSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: featuresSchema,
    Thumbnail: FeaturesThumbnail
  },
  howitworks: {
    Component: HowItWorksSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: howItWorksSchema,
    Thumbnail: HowItWorksThumbnail
  },
  gallery: {
    Component: GallerySection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: gallerySchema,
    Thumbnail: GalleryThumbnail
  },
  pricing: {
    Component: PricingSection,
    Settings: PricingSettings,
    schema: pricingSchema,
    Thumbnail: PricingThumbnail
  },
  testimonials: {
    Component: TestimonialsSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: testimonialsSchema,
    Thumbnail: TestimonialsThumbnail
  },
  contact: {
    Component: ContactSection,
    Settings: ContactSettings,
    schema: contactSchema,
    Thumbnail: ContactThumbnail
  },
  offices: {
    Component: OfficesSection,
    Settings: OfficesSettings,
    schema: officesSchema,
    Thumbnail: OfficesThumbnail
  },
  buttonsection: {
    Component: ButtonSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: buttonSectionSchema,
    Thumbnail: ButtonSectionThumbnail
  },
  richtext: {
    Component: RichText,
    Settings: RichTextSettings,
    schema: richTextSchema,
    Thumbnail: RichTextThumbnail
  },
  faq: {
    Component: FAQ,
    Settings: null, // Uses schema-driven AutoSettings
    schema: faqSchema,
    Thumbnail: FAQThumbnail
  },
  divider: {
    Component: Divider,
    Settings: null, // Uses schema-driven AutoSettings
    schema: dividerSchema,
    Thumbnail: DividerThumbnail
  },
  navigation: {
    Component: NavigationSection,
    Settings: NavigationSettings,
    schema: navigationSchema,
    Thumbnail: NavigationThumbnail
  },
  video: {
    Component: VideoSection,
    Settings: null, // Uses schema-driven AutoSettings
    schema: videoSchema,
    Thumbnail: VideoThumbnail
  }
};

// ============================================
// API для UI (библиотека компонентов, рендер)
// ============================================

/**
 * Получить список секций для библиотеки компонентов
 */
export function getSectionsList() {
  return Object.entries(sections).map(([key, section]) => ({
    id: section.schema.id,
    name: section.schema.title,
    description: section.schema.description,
    icon: section.schema.icon,
    category: section.schema.category,
    defaultData: section.schema.default,
    Thumbnail: section.Thumbnail
  }));
}

/**
 * Получить компонент секции по типу
 */
export function getSectionComponent(type) {
  return sections[type]?.Component || null;
}

/**
 * Получить настройки секции по типу
 */
export function getSectionSettings(type) {
  return sections[type]?.Settings || null;
}

/**
 * Получить дефолтные данные секции по типу
 */
export function getSectionDefaultData(type) {
  return sections[type]?.schema.default || {};
}

// ============================================
// API для AI (схемы, документация)
// ============================================

/**
 * Получить полную JSON Schema секции для AI
 * @param {string} type - Тип секции
 * @returns {Object|null} JSON Schema секции
 */
export function getSectionSchema(type) {
  const section = sections[type];
  if (!section) return null;
  // Return the raw JSON schema (without migrate function)
  const { migrate, ...schema } = section.schema;
  return schema;
}

/**
 * Получить все схемы секций для AI
 * Используется для генерации документации или передачи AI контекста
 * @returns {Object} Объект со всеми схемами
 */
export function getAllSectionSchemas() {
  const schemas = {};
  for (const [type, section] of Object.entries(sections)) {
    schemas[type] = getSectionSchema(type);
  }
  return schemas;
}

/**
 * Получить краткую документацию всех секций для AI
 * @returns {Array} Массив с краткими описаниями секций
 */
export function getSectionsSummary() {
  return Object.entries(sections).map(([type, section]) => {
    const { schema } = section;
    const contentFields = schema.properties
      ? Object.keys(schema.properties)
      : [];

    return {
      type,
      name: schema.title,
      description: schema.description,
      category: schema.category,
      version: schema.version,
      contentFields
    };
  });
}

/**
 * Валидировать данные секции по схеме
 * @param {string} type - Тип секции
 * @param {Object} content - Данные контента
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validateSectionContent(type, content) {
  const section = sections[type];
  if (!section) {
    return { valid: false, errors: [`Неизвестный тип секции: ${type}`] };
  }

  const { validateData } = require('./schema-types');
  return validateData(content, section.schema);
}

/**
 * Создать новую секцию с дефолтными данными
 * @param {string} type - Тип секции
 * @param {Object} [overrides] - Переопределения данных
 * @returns {Object|null} Объект секции
 */
export function createSection(type, overrides = {}) {
  const section = sections[type];
  if (!section) return null;

  const { schema } = section;

  return {
    id: `section-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    type: schema.id,
    version: schema.version,
    content: {
      ...schema.default,
      ...overrides.content
    },
    styles: {
      paddingTop: schema['x-styles']?.paddingTop ?? 64,
      paddingBottom: schema['x-styles']?.paddingBottom ?? 64,
      backgroundColor: '#FFFFFF',
      ...overrides.styles
    }
  };
}
